import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Calc icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Calc } from '@sravni/design-system-icons'
 *
 * <Calc />
 * ```
 */
var Calc = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Calc", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.333 15h2.5M12.333 12.5h2.5M2.5 10h15M17.5 15.543c0 1.081-.877 1.957-1.957 1.957H4.457A1.956 1.956 0 0 1 2.5 15.543V4.457c0-1.081.876-1.957 1.957-1.957h11.086c1.08 0 1.957.876 1.957 1.957v11.086ZM12.5 6.25H15M5 6.25h2.5M6.25 7.5V5M5.367 12.867l1.766 1.766M5.367 14.633l1.766-1.766M10 2.5v15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Calc };
//# sourceMappingURL=Calc.js.map
